<template>
<div class="config-wrap">
    <van-nav-bar title="我的" fixed :placeholder="true" />
    <div>
        <!-- <van-cell title="用户名" :value="userInfo.nickName" /> -->
        <!-- 个人信息卡片 -->
        <div class="user-info-card">
            <div class="user-profile">
                <div class="avatar">
                    <van-icon name="user-o" size="30" color="#666" />
                </div>
                <div class="user-details">
                    <div class="user-name-row">
                        <span class="user-nickname">{{ userInfo.nickName || '用户昵称' }}</span>
                        <span class="user-level" @click="goToMember">{{ userInfoData.memberLevel }}</span>
                    </div>
                    <div class="user-id">ID: {{ userInfo.id || '5009' }}</div>
                </div>
            </div>
        </div>

        <van-cell title="收款信息" label="查看微信、支付宝收款资料，补填未填写的方式" is-link to="/receipt-info" />
        <!-- 余额信息卡片 -->
        <div class="balance-card">
            <!-- 上半部分：余额信息 -->
            <div class="balance-top">
                <div class="balance-info">
                    <div class="balance-title">我的余额(元)</div>
                    <div class="balance-amount">{{ amount }}</div>
                </div>
                <van-button type="danger" size="small" @click="withdraw" class="withdraw-btn">申请提现</van-button>
            </div>
            <!-- 下半部分：详细信息 -->
            <div class="balance-bottom">
                <div class="balance-detail-item">
                    <span class="detail-label">待结算(元)</span>
                    <span class="detail-value">{{ freeze_amount }}</span>
                </div>
                <div class="balance-detail-item">
                    <span class="detail-label">本月收入(元)</span>
                    <span class="detail-value">{{ income_amount }}</span>
                </div>
            </div>
        </div>

        <!-- 功能小面板 -->
        <div class="function-panel">
            <div class="panel-row">
                <div class="panel-item" @click="goToPoints">
                    <div class="item-icon"><van-icon name="gold-coin-o" /></div>
                    <div class="item-title">我的积分</div>
                    <div class="item-value">{{ points }}分</div>
                </div>
                <div class="panel-item" @click="showBidCountDialog">
                    <div class="item-icon"><van-icon name="orders-o" /></div>
                    <div class="item-title">竞价单数</div>
                    <div class="item-value">{{ bidCount }}单</div>
                </div>
                <div class="panel-item" @click="goToBidNotifySettings">
                    <div class="item-icon"><van-icon name="volume-o" /></div>
                    <div class="item-title">中单通知</div>
                    <div class="item-value">设置</div>
                </div>
            </div>
            <div class="panel-row">
                <div class="panel-item panel-item-with-switch" @click="goToNewOrderNotify">
                    <div class="item-icon"><van-icon name="bullhorn-o" /></div>
                    <div class="item-title">新单通知 ></div>
                    <van-switch
                        :value="autoWxAlarmNewOrder"
                        size="22"
                        @input="onNewOrderNotifySwitch"
                        @click.native.stop
                    />
                </div>
                <div class="panel-item" @click="goToPCLogin">
                    <div class="item-icon"><van-icon name="desktop-o" /></div>
                    <div class="item-title">PC登录</div>
                    <div class="item-value">登录</div>
                </div>
                <div class="panel-item" @click="goToCinemaClass">
                    <div class="item-icon"><van-icon name="cluster-o" /></div>
                    <div class="item-title">影院分类</div>
                    <div class="item-value">设置</div>
                </div>
            </div>
        </div>

       

       
    </div>
    
    <!-- 版本信息和退出登录 -->
    <div class="footer-section">
        <div class="version-info">
            <span class="version-text">版本号：v{{ version }}</span>
        </div>
        <!-- <div class="logout-section">
            <van-button round type="danger" @click="beforeLogout">退出登录</van-button>
        </div> -->
    </div>

    <!-- 修改密码
    <van-dialog v-model="showDialog" title="修改密码" @close="showDialog = false" @confirm="handleConfirm" @cancel="handleCancel">
        <van-field v-model="password" type="password" label="密码" placeholder="请输入密码" />
        <template #footer>
            <van-button text @click="handleCancel">取消</van-button>
            <van-button type="primary" @click="handleConfirm">修改</van-button>
        </template>
    </van-dialog>
     -->

    <!-- 竞价数设置对话框 -->
    <van-dialog 
        v-model="showBidCountDialogVisible" 
        title="竞价单数设置" 
        :show-cancel-button="true"
        :show-confirm-button="true"
        cancel-button-text="取消"
        confirm-button-text="保存"
        @close="showBidCountDialogVisible = false" 
        @confirm="saveBidCount" 
        @cancel="cancelBidCount"
    >
        <div style="padding: 20px;">
            <div style="margin-bottom: 15px; color: #666; font-size: 14px;">
                设置同时参与竞价的最大单数，建议根据您的出票资源合理设置，最大值为当前账号的最多同时竞价单数
            </div>
            <van-field 
                v-model="tempBidCount" 
                type="number" 
                label="竞价单数:" 
                :placeholder="`请输入1-${maxBidCount}之间的数字`"
                class="bid-input-field"
            />
            <div style="margin-top: 5px; color: red; font-size: 12px; padding-left: 16px;">
                当前账号最大值：{{ maxBidCount }} 单
            </div>
        </div>
    </van-dialog>
</div>
</template>

<script>
import {
    mapActions,
    mapGetters
} from 'vuex';

import Api from '@/api-service'

export default {
    data() {
        return {
            show: false,
            amount: 0.0,
            freeze_amount:0.0,
            income_amount:0.0,
            points: 0,
            showDialog: false, // 控制对话框显示
            password: '', // 绑定密码输入框的值
            code: '',
            autoBid: false,
            autoAlarmNewOrder: false,
            autoAlarmBidOrder: false,
            autoWxAlarmNewOrder: false,
            autoWxAlarmBidOrder: false,
            url:'http://merchant.24xiaoshi.online/',
            userInfoData: {}, // 新的用户信息数据
            bidCount: 1, // 同时竞价单数
            showBidCountDialogVisible: false, // 竞价数设置对话框
            tempBidCount: 1, // 临时竞价数（用于对话框编辑）
            maxBidCount: 10, // 账号最大竞价单数
            version: '2.3.0', // 版本号
        };
    },
    computed: {
        ...mapGetters(['hasGetUserInfo']),
        userInfo() {
            return this.$store.state.user.userInfo;
        },
    },
    created() {
        // 如果没有登录，跳转到登录页
        this.getWithdrawAmount()
        this.makeCode()
        console.log(this.userInfo)
        this.autoBid = this.userInfo.auto == 1
        this.autoAlarmNewOrder = this.userInfo.order_tip_type == 1
        this.autoAlarmBidOrder = this.userInfo.alarm_type == 1
        this.autoWxAlarmNewOrder = this.userInfo.wx_new_order_type == 1
        this.autoWxAlarmBidOrder = this.userInfo.wx_bid_order_type == 1
        this.bidCount = this.userInfo.bid_count;
        console.log('created() 中的 bidCount:', this.bidCount);
        console.log('created() 中的 userInfo:', this.userInfo);

        // this.getPoints();
        this.getUserInfoData(); // 获取新的用户信息
    },
    methods: {
        ...mapActions(['logout']),
        // 获取新的用户信息
        getUserInfoData() {
            Api.getUserInfoNew().then(res => {
                console.log('用户信息:', res);
                this.userInfoData = res;
                // 更新积分显示
                this.points = res.points || 0;
                // 更新竞价数设置
                this.maxBidCount = res.maxBidCount || 3;
                this.bidCount = this.bid_count || this.maxBidCount;
                console.log('最终设置的 bidCount:', this.bidCount);
            }).catch(error => {
                console.error('获取用户信息失败:', error);
                // 如果获取失败，使用store中的默认值
                this.maxBidCount = 3;
                this.bidCount = this.bid_count || this.maxBidCount;
            });
        },
        // 获取状态样式类
        getStatusClass(status) {
            if (status === 1) return 'status-normal';
            if (status === 2) return 'status-warning';
            if (status === 3) return 'status-danger';
            return 'status-normal';
        },
        // 计算进度百分比
        getProgressPercent() {
            const current = this.userInfoData.currentExp || 0;
            const next = this.userInfoData.nextLevelExp || 100;
            if (next === 0) return 100;
            return Math.min((current / next) * 100, 100);
        },
        // 格式化金额
        formatMoney(amount) {
            return parseFloat(amount || 0).toFixed(2);
        },
        beforeLogout() {
            this.$dialog
                .confirm({
                    title: '系统提示',
                    message: '确认退出登录吗?',
                })
                .then(() => {
                    this.logout();
                });
        },
        ruleDetail() {
            this.$router.push("/cinema/rule")
        },
        withdraw() {
            this.$router.push({
                path: '/withdraw',
                query: {
                    amount: this.amount
                }
            })
        },
        setAuto(item) {
            let data = {}
            if (item == 1) {
                data.bid_type = this.autoBid ? 1 : 2
            } else if (item == 2) {
                data.alarm_type = this.autoAlarmBidOrder ? 1 : 2
            } else if (item == 3) {
                data.order_tip_type = this.autoAlarmNewOrder ? 1 : 2
            } else if (item == 4) {
                data.wx_new_order_type = this.autoWxAlarmNewOrder ? 1 : 2
            } else if (item == 5) {
                data.wx_bid_order_type = this.autoWxAlarmBidOrder ? 1 : 2
            }

            Api.setAutoStatus(data).then(res => {
                this.$notify({
                    type: 'success',
                    message: '操作成功'
                });

                // if (data.bid_type == 2) {
                //     if(item == 1) {
                //         this.userInfo.auto = 2
                //     } else if (item == 2) {
                //         this.userInfo.alarm_type = 2
                //     } else if (item == 3) {
                //         this.userInfo.order_tip_type = 2
                //     }

                // } else {
                //     if(item == 1) {
                //         this.userInfo.auto = 1
                //     } else if (item == 2) {
                //         this.userInfo.alarm_type = 1
                //     } else if (item == 3) {
                //         this.userInfo.order_tip_type = 1
                //     }
                // }

                console.log(this.userInfo)

            })
        },
        getWithdrawAmount() {

            Api.getWithdrawAmount({}).then(res => {
                this.amount = res.amount
                this.freeze_amount = res.freeze_amount
                this.income_amount = res.cur_month_amount
            })
        },
        makeCode() {
            Api.makeCode({}).then(res => {
                this.code = res.code
            })
        },
        changePwd() {
            //   this.$router.push({path:'/change/pwd'})
        },
        handleConfirm() {
            // 确认按钮的逻辑
            console.log('新密码:', this.password);
            // 这里可以添加发送新密码到服务器的代码
            this.showDialog = false;
        },
        handleCancel() {
            // 取消按钮的逻辑
            this.showDialog = false;
        },
        async copy() {
            try {
                const content = this.url;
                // 调用浏览器 API 复制内容到剪贴板
                await navigator.clipboard.writeText(content);
                // 复制成功后的提示
                this.$toast.success('内容已复制到剪贴板');
            } catch (err) {
                // 复制失败的错误处理
                console.error('复制失败:', err);
                this.$toast.fail('复制失败');
            }
        },
        goToPoints() {
            this.$router.push({
                path: '/points',
                query: {
                    points: this.userInfoData.points || this.points || 0
                }
            });
        },
        getPoints() {
            Api.getUserPoints().then(res => {
                this.points = res.points;
            });
        },
        goToMember() {
            this.$router.push('/member');
        },
        
        // 显示竞价数设置对话框
        showBidCountDialog() {
            this.tempBidCount = this.bidCount;
            this.showBidCountDialogVisible = true;
        },
    
        
    
        
        // 保存竞价数设置
        saveBidCount() {
            const count = parseInt(this.tempBidCount);
            if (isNaN(count) || count < 1 || count > this.maxBidCount) {
                this.$toast.fail(`请输入1-${this.maxBidCount}之间的有效数字`);
                return;
            }
            
            Api.setAutoStatus({ bid_count: count }).then(res => {
                this.bidCount = count;
                // 更新userInfo中的bid_count
                this.$store.commit('setUserInfo', {
                    ...this.userInfo,
                    bid_count: count
                });
                this.showBidCountDialogVisible = false;
                this.$toast.success('设置成功');
            }).catch(err => {
                console.error('保存竞价数设置失败:', err);
                this.$toast.fail('设置失败，请重试');
            });
        },
        
        // 取消竞价数设置
        cancelBidCount() {
            this.showBidCountDialogVisible = false;
        },
        
        // 中单通知设置
        goToBidNotifySettings() {
            this.$router.push('/bid-notify-settings');
        },
        // 新订单通知条件列表页
        goToNewOrderNotify() {
            this.$router.push('/new-order-notify');
        },
        // 新单通知总开关，直接开关并同步服务端
        onNewOrderNotifySwitch(enabled) {
            this.autoWxAlarmNewOrder = enabled;
            Api.setAutoStatus({ wx_new_order_type: enabled ? 1 : 2 }).then(() => {
                this.$toast.success(enabled ? '已开启' : '已关闭');
                const userInfo = { ...this.userInfo };
                userInfo.wx_new_order_type = enabled ? 1 : 2;
                this.$store.commit('setUserInfo', userInfo);
            }).catch(() => {
                this.autoWxAlarmNewOrder = !enabled;
                this.$toast.fail('设置失败');
            });
        },
        
        // 跳转到PC登录
        goToPCLogin() {
            this.$router.push('/pc-login');
        },
        goToCinemaClass() {
            this.$router.push('/cinema-class');
        },
    }

};
</script>

<style lang="scss" scoped>
.config-wrap {
    background-color: #f7f7fa;
    min-height: 100vh;
    padding-bottom: 20px;

    .user-info-card {
        margin: 16px;
        padding: 16px;
        background: white;
        border-radius: 16px;
        box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);

        .user-profile {
            display: flex;
            align-items: center;

            .avatar {
                width: 48px;
                height: 48px;
                border-radius: 50%;
                background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
                display: flex;
                align-items: center;
                justify-content: center;
                margin-right: 16px;
                box-shadow: 0 4px 12px rgba(102, 126, 234, 0.3);

                .van-icon {
                    color: white;
                    font-size: 22px;
                }
            }

            .user-details {
                flex: 1;

                                .user-name-row {
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    margin-bottom: 8px;

                    .user-nickname {
                        font-size: 18px;
                        font-weight: 600;
                        color: #2c3e50;
                        letter-spacing: 0.5px;
                    }

                    .user-level {
                        font-size: 11px;
                        font-weight: 500;
                        background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
                        color: white;
                        padding: 2px 8px;
                        border-radius: 16px;
                        box-shadow: 0 2px 8px rgba(102, 126, 234, 0.3);
                        cursor: pointer;
                        transition: all 0.3s ease;
                        
                        &:hover {
                            transform: translateY(-1px);
                            box-shadow: 0 4px 12px rgba(102, 126, 234, 0.4);
                        }
                        
                        &:active {
                            transform: translateY(0);
                        }
                    }
                }

                .user-id {
                    font-size: 14px;
                    color: #7f8c8d;
                    font-weight: 400;
                    letter-spacing: 0.3px;
                }
            }
        }
    }

    .function-panel {
        margin: 16px;
        background: white;
        border-radius: 16px;
        box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
        overflow: hidden;

        .panel-row {
            display: flex;
            border-bottom: 1px solid #f5f5f5;

            &:last-child {
                border-bottom: none;
            }

            .panel-item {
                flex: 1;
                display: flex;
                flex-direction: column;
                align-items: center;
                padding: 20px 12px;
                cursor: pointer;
                transition: all 0.3s ease;
                position: relative;

                &:not(:last-child) {
                    border-right: 1px solid #f5f5f5;
                }

                &:hover {
                    background: rgba(102, 126, 234, 0.05);
                }

                &:active {
                    background: rgba(102, 126, 234, 0.1);
                    transform: scale(0.98);
                }

                .item-icon {
                    font-size: 24px;
                    margin-bottom: 8px;
                    filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.1));
                }

                .item-title {
                    font-size: 12px;
                    color: #7f8c8d;
                    font-weight: 500;
                    margin-bottom: 4px;
                    letter-spacing: 0.3px;
                }

                .item-value {
                    font-size: 14px;
                    color: #2c3e50;
                    font-weight: 600;
                    letter-spacing: 0.3px;
                }

                &.panel-item-with-switch {
                    .van-switch {
                        margin-top: 4px;
                    }
                }

                // 空项样式
                &:empty {
                    cursor: default;
                    
                    &:hover, &:active {
                        background: transparent;
                        transform: none;
                    }
                }
            }
        }
    }

    .order-status {
        display: flex;
        justify-content: space-around;
        background: white;
        margin: 16px;
        padding: 24px;
        border-radius: 16px;
        box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);

        .status-item {
            display: flex;
            flex-direction: column;
            align-items: center;

            .status-icon {
                font-size: 24px;
                margin-bottom: 12px;
                filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.1));
            }

            .status-label {
                font-size: 12px;
                color: #7f8c8d;
                font-weight: 500;
                letter-spacing: 0.3px;
            }
        }
    }

    .balance-card {
        background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
        margin: 16px;
        padding: 20px;
        border-radius: 16px;
        box-shadow: 0 4px 20px rgba(102, 126, 234, 0.3);
        color: white;

        .balance-top {
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-bottom: 16px;

            .balance-info {
                .balance-title {
                    font-size: 14px;
                    color: rgba(255, 255, 255, 0.8);
                    margin-bottom: 6px;
                    font-weight: 500;
                    letter-spacing: 0.3px;
                }

                .balance-amount {
                    font-size: 28px;
                    font-weight: 700;
                    color: white;
                    letter-spacing: 1px;
                }
            }

            .withdraw-btn {
                background: rgba(255, 255, 255, 0.2);
                border: 1px solid rgba(255, 255, 255, 0.3);
                color: white;
                font-size: 12px;
                font-weight: 500;
                padding: 6px 12px;
                border-radius: 16px;
                letter-spacing: 0.3px;
            }
        }

        .balance-bottom {
            display: flex;
            justify-content: space-between;
            padding-top: 16px;
            border-top: 1px solid rgba(255, 255, 255, 0.2);

            .balance-detail-item {
                display: flex;
                flex-direction: column;
                align-items: flex-start;

                .detail-label {
                    font-size: 12px;
                    color: rgba(255, 255, 255, 0.7);
                    font-weight: 400;
                    margin-bottom: 4px;
                    letter-spacing: 0.2px;
                }

                .detail-value {
                    font-size: 16px;
                    color: white;
                    font-weight: 600;
                    letter-spacing: 0.3px;
                }
            }
        }
    }
}

.custom-input {
    width: 80%;
    height: 100%;
}

.bid-count-cell {
    ::v-deep .van-cell__value {
        color: red !important;
    }
}

.withdraw-cell {
    ::v-deep .van-cell__value {
        color: #ee0a24 !important;
    }
}

.points-cell {
    ::v-deep .van-cell__value {
        color: #07c160 !important;
    }
}

.bid-input-field {
    ::v-deep .van-field__control {
        border-bottom: 1px solid #ddd;
        padding-bottom: 5px;
    }
}

/* 全局优化van-cell样式 */
::v-deep .van-cell {
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
    
    .van-cell__title {
        font-size: 15px;
        font-weight: 500;
        color: #2c3e50;
        letter-spacing: 0.3px;
    }
    
    .van-cell__value {
        font-size: 14px;
        font-weight: 400;
        color: #7f8c8d;
        letter-spacing: 0.2px;
    }
    
    .van-cell__label {
        font-size: 12px;
        color: #95a5a6;
        font-weight: 400;
        letter-spacing: 0.2px;
    }
}

/* 优化分割线样式 */
::v-deep .van-divider {
    font-size: 14px;
    font-weight: 600;
    color: #2c3e50;
    letter-spacing: 0.5px;
}

.footer-section {
    padding: 20px 16px;
    margin-top: 20px;

    .version-info {
        text-align: center;
        margin-bottom: 20px;

        .version-text {
            font-size: 12px;
            color: #95a5a6;
            font-weight: 400;
            letter-spacing: 0.2px;
        }
    }

    .logout-section {
        text-align: center;

        .van-button {
            width: 120px;
            height: 40px;
            font-size: 14px;
            font-weight: 500;
            letter-spacing: 0.3px;
        }
    }
}
</style>
